
import { Button } from "@/components/ui/button";
import { Icons } from "@/components/ui/icons";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

interface SocialSignUpButtonsProps {
  onSuccess: () => void;
}

export const SocialSignUpButtons = ({ onSuccess }: SocialSignUpButtonsProps) => {
  const { toast } = useToast();

  const handleSocialSignUp = async (provider: 'google' | 'azure') => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
          redirectTo: `${window.location.origin}/training`,
        },
      });
      
      if (error) throw error;
      
      onSuccess();
    } catch (error) {
      console.error('Error:', error);
      toast({
        title: "Error signing up",
        description: "Failed to sign up with social provider. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="grid gap-4">
      <Button
        variant="outline"
        onClick={() => handleSocialSignUp('google')}
        className="w-full"
        type="button"
      >
        <Icons.google className="mr-2 h-4 w-4" />
        Sign up with Google
      </Button>
      
      <Button
        variant="outline"
        onClick={() => handleSocialSignUp('azure')}
        className="w-full"
        type="button"
      >
        <Icons.microsoft className="mr-2 h-4 w-4" />
        Sign up with Microsoft
      </Button>

      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">
            Or continue with email
          </span>
        </div>
      </div>
    </div>
  );
};
